<canvas id="chart" #chart height="300"></canvas>